interface ClaimBusinessParams {
  businessId?: number;
  googlePlaceId?: string;
  authUserId: string;
  trade: string;
}

interface ClaimBusinessResponse {
  success: boolean;
  message: string;
  channel: 'sms' | 'call';
  phoneLastFour: string;
  businessId: number;
  businessName: string;
  expiresAt: string;
  dev_token?: string;
  dev_message?: string;
}

interface VerifyBusinessParams {
  code: string;
  businessId: number;
  authUserId: string;
}

interface VerifyBusinessResponse {
  success: boolean;
  message: string;
  business: {
    id: number;
    company_name: string;
    profile_claimed: boolean;
    is_authorized: number;
  };
}

interface PlacesSearchParams {
  trade: string;
  postcode: string;
  radius?: number;
}

interface PlacesSearchResult {
  id?: number;
  company_name: string;
  phone: string | null;
  phone_last_four: string | null;
  address: string | null;
  postcode: string | null;
  google_place_id: string | null;
  is_local: boolean;
  is_claimed: boolean;
  latitude: number | null;
  longitude: number | null;
}

interface PlacesSearchResponse {
  success: boolean;
  results: PlacesSearchResult[];
  total: number;
}

const API_BASE = import.meta.env.DEV ? 'http://localhost:3001' : '';

export async function searchPlaces(params: PlacesSearchParams): Promise<PlacesSearchResponse> {
  const response = await fetch(`${API_BASE}/api/places/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Search failed');
  }

  return response.json();
}

export async function claimBusiness(params: ClaimBusinessParams): Promise<ClaimBusinessResponse> {
  const response = await fetch(`${API_BASE}/api/locksmiths/claim`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to initiate claim');
  }

  return response.json();
}

export async function verifyBusiness(params: VerifyBusinessParams): Promise<VerifyBusinessResponse> {
  const response = await fetch(`${API_BASE}/api/locksmiths/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Verification failed');
  }

  return response.json();
}

export type { PlacesSearchResult, ClaimBusinessResponse, VerifyBusinessResponse };
